import React from "react";
import { Button, Card } from "react-bootstrap";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import img1 from "./images/turbodirect.gif";
import img2 from "./images/newellauto.gif";
import img3 from "./images/marsreport.gif";
import img4 from "./images/xcompact.gif";
import img5 from "./images/rattlescan.gif";
import img6 from "./images/liquidgold.JPG";

import "./style";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));

export default function PortfolioItems() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        
        <Grid item xs={12} >
          <Card className="text-center" >
            <Card.Header className="card-title">Liquid Gold Coffee</Card.Header>
            <Card.Img
              className="mx-auto"
              variant="top"
              src={img6}
              style={{ height: "auto", width: "85%" }}
            />
            <Card.Body>
              <Card.Text>
                The goal of this project was to build a clean and seamless point
                of communication for a up and coming mobile coffee truck
                business. Using React and Material UI, I accomplished just that.
                Fast, Clean and Modern was the goal in this project.
              </Card.Text>
              <br />

              <Button
                variant="success"
                size="md"
                block
                href="https://liquidgoldcoffee.netlify.com"
                target="_blank"
              >
                View Project
              </Button>
              <Button
                variant="dark"
                size="md"
                block
                href="https://github.com/NateSpring/liquid-gold-coffee"
                target="_blank"
              >
                Github Repo
              </Button>
            </Card.Body>
            <Card.Footer>Created With: React, Material UI</Card.Footer>
          </Card>
        </Grid>

        <Grid item xs={12} >
          <Card className="text-center" >
            <Card.Header className="card-title">X-Compact Drones</Card.Header>
            <Card.Img
              className="mx-auto"
              variant="top"
              src={img4}
              style={{ height: "auto", width: "85%" }}
            />
            <Card.Body>
              <Card.Text>
                This static frontend langing page was built for a drone startup;
                X-Compact. The technologies used were React and various
                libraries to bring a modern web page to life.
              </Card.Text>
              <br />
              <Button
                variant="success"
                size="md"
                block
                href="https://xcompact.netlify.com"
                target="_blank"
              >
                View Project
              </Button>
              <Button
                variant="dark"
                size="md"
                block
                href="https://github.com/NateSpring/NewellAutoService"
                target="_blank"
              >
                Github Repo
              </Button>
            </Card.Body>
            <Card.Footer>Created With: React</Card.Footer>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card className="text-center" >
            <Card.Header className="card-title">Turbo Direct</Card.Header>
            <Card.Img
              className="mx-auto turboDirect"
              href="https://turbodirect.netlify.com"
              variant="top"
              src={img1}
              style={{ height: "auto", width: "85%" }}
            />
            <Card.Body>
              <Card.Text>
                Turbo Direct is a small E-Commerce store for hard to find
                turbochargers. This webpage was built with React and Bootstrap 4
                for a clean and modern feeling. Each item can be added to a cart
                with the option to add a shipping charge.
              </Card.Text>
              <br />
              <Button
                variant="success"
                size="lg"
                block
                href="https://turbodirect.netlify.com"
                target="_blank"
              >
                View Project
              </Button>
              <Button
                variant="dark"
                size="lg"
                block
                href="https://github.com/NateSpring/TurboDirect"
                target="_blank"
              >
                Github Repo
              </Button>
            </Card.Body>
            <Card.Footer>Created With: React, Redux</Card.Footer>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card className="text-center" >
            <Card.Header className="card-title">
              Newell Auto Service
            </Card.Header>
            <Card.Img
              className="mx-auto"
              variant="top"
              src={img2}
              style={{ height: "auto", width: "85%" }}
            />
            <Card.Body>
              <Card.Text>
                Built for a local mobile automotive-repair service, this web
                page utilizes Gatsby.js as an extension of React for lightning
                fast speed between pages. This web page was increased
                customer-acquisition significantly.
              </Card.Text>
              <br />
              <Button
                variant="success"
                size="lg"
                block
                href="https://newellautoservice.netlify.com"
                target="_blank"
              >
                View Project
              </Button>
              <Button
                variant="dark"
                size="lg"
                block
                href="https://github.com/NateSpring/NewellAutoService"
                target="_blank"
              >
                Github Repo
              </Button>
            </Card.Body>
            <Card.Footer>Created With: React, Gatsby</Card.Footer>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card className="text-center" >
            <Card.Header className="card-title">RattleScan</Card.Header>
            <Card.Img
              className="mx-auto"
              variant="top"
              src={img5}
              style={{ height: "auto", width: "85%" }}
            />
            <Card.Body>
              <Card.Text>
                This web app is for finding and reporting rattlesnake sightings.
                Other users can use this information to avoid potentially
                dangerous areas. Skills: JavaScript, HTML, CSS, Google Maps API.{" "}
              </Card.Text>
              <br />

              <Button
                variant="success"
                size="lg"
                block
                href="https://rattlescan.netlify.com"
                target="_blank"
              >
                View Project
              </Button>
              <Button
                variant="dark"
                size="lg"
                block
                href="https://github.com/NateSpring/RattleScan"
                target="_blank"
              >
                Github Repo
              </Button>
            </Card.Body>
            <Card.Footer>Created With: JavaScript, GoogleMaps API</Card.Footer>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card className="text-center" >
            <Card.Header className="card-title">Mars Weather App</Card.Header>
            <Card.Img
              className="mx-auto"
              variant="top"
              src={img3}
              style={{ height: "auto", width: "85%" }}
            />
            <Card.Body>
              <Card.Text>
                Ever wonder how cold Mars is right now? This web app brings that
                very information to you and more. This captures data from the
                InSight Rover on Mars and parses it into a readable UI. Built
                from scratch with React.JS.{" "}
              </Card.Text>
              <br />

              <Button
                variant="success"
                size="lg"
                block
                href="https://marsweather.netlify.com"
                target="_blank"
              >
                View Project
              </Button>
              <Button
                variant="dark"
                size="lg"
                block
                href="https://github.com/NateSpring/MarsWeatherForecast"
                target="_blank"
              >
                Github Repo
              </Button>
            </Card.Body>
            <Card.Footer>Created With: React, Nasa API</Card.Footer>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/PortfolioPage/portfolio-items.js